import { ref } from "vue";
import { saveAs } from "file-saver";
import { StorageController } from "@rmp/core/api/storage";
import AbortService from "@rmp/core/services/abortService";
import { useAppStore } from "@rmp/core/stores/appStore";

export function useFileDownload() {
	const abortService = new AbortService();
	const storageController = new StorageController(abortService);

	const downloading = ref(false);

	const download = async (fileId: string, fileName: string) => {
		abortService.initialize();
		downloading.value = true;

		try {
			const file = await storageController.getFile(fileId);

			saveAs(file, fileName);
		} catch (error) {
			useAppStore().handleActionError(error);
		} finally {
			downloading.value = false;
		}
	};

	return {
		downloading,
		download
	};
}
